import { setIsVisible } from 'Helper/domHelper';
import { is5g } from '../helper/additionalPageOptionsHelper';
import { CLASSNAME_IMAGE_TEXT_IMAGE, WRAPPER_ID_IMAGE_TEXT } from 'Constant';

export const toggleQualitySeal = (selectedHardwareId?: string) => {
    const qualitySealElement = document
        .getElementById(WRAPPER_ID_IMAGE_TEXT)
        ?.getElementsByClassName(CLASSNAME_IMAGE_TEXT_IMAGE)[0] as HTMLElement;

    qualitySealElement && setIsVisible(qualitySealElement, is5g(selectedHardwareId));
};
